import type { ListBuilderList } from '../../../types';

/**
 * Coming Due — every non-terminal SR with a `targetDate` in the
 * future, sorted by date ASC so the soonest deadline floats to the
 * top. No upper bound on the date range: this tab is the
 * deadline-pressure view for everything from "due tomorrow" all the
 * way out to "due in 6 months", which makes it a useful single
 * place to plan instead of forcing the user to switch between a
 * 7-day and 30-day window.
 *
 * Replaces the original "next 7 days only" framing — anything that
 * had a target date but was outside the 7-day window was previously
 * invisible from this tab, which was the opposite of what the team
 * wanted.
 *
 * The `{{TODAY}}` start filter is resolved by
 * `FilterRulesService.processDynamicDatesInObject` before the
 * filter hits the API.
 */
export const comingDueList: ListBuilderList = {
	id: 'default-sourcing-requests-coming-due',
	cacheTTL: 300000,
	name: 'Coming Due',
	type: 'default',
	active: true,
	sortOrder: 2,
	defaultSortId: 'column-sr-target-date-asc',
	filterRules: {
		sourcingRequestAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
		},
		sourcingRequestStatus: {
			defaultValue: [
				{ id: 'draft', label: 'Draft' },
				{ id: 'open', label: 'Open' },
				{ id: 'in_progress', label: 'In Progress' },
				{ id: 'partially_fulfilled', label: 'Partially Fulfilled' },
			],
			locked: true,
			hidden: true,
		},
		sourcingRequestTargetDateRange: {
			// Open-ended upper bound: only the start matters here. The
			// filter UI still lets the user narrow it if they want a
			// specific window.
			defaultValue: {
				startDate: '{{TODAY}}',
				endDate: '',
			},
			locked: true,
			hidden: false,
		},
	},
	inheritsFrom: 'default-sourcing-requests-all',
};
